module.exports = "<svg viewBox=\"0 0 299.2 110\"><path d=\"M131.5 54.8c0-29-23.5-52.5-52.5-52.5-44.3 0-79 38.3-79 87.2h18.9c0-38.3 26.4-68.3 60.1-68.3 18.6 0 33.6 15.1 33.6 33.6 0 8.5-6.6 15.7-15.1 16.4 6.7-4.3 8.7-13.2 4.5-19.9-2.6-4.2-7.2-6.7-12.1-6.7-5.2 0-10.1 2.1-13.7 5.7-3.6 3.7-5.6 8.6-5.6 13.7 0 6.9 2.7 13.5 7.6 18.5 4.7 4.9 11.2 7.6 18 7.7h.4c19.3-.2 34.9-16 34.9-35.4z\" class=\"st0\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/icon-design.svg
// module id = 284
// module chunks = 1